//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willNew_identity_role from './willNew_identity_role';
export const willNew_identity_role = _willNew_identity_role;
export default {willNew_identity_role};

